// src/app/core/permissions/permission.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { normalizeAll, NormalizedPermission, RawPermission } from './permission-normalizer';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly _perms$ = new BehaviorSubject<Set<NormalizedPermission>>(new Set());
  readonly perms$ = this._perms$.asObservable();

  /** نمرر مصفوفة الباك كما هي (list users...) */
  loadFromBackend(rawPerms: RawPermission[] | null | undefined) {
    const normalized = normalizeAll(rawPerms ?? []);
    this._perms$.next(new Set(normalized));
  }

  clear() { this._perms$.next(new Set()); }

  can(perm: NormalizedPermission): boolean { return this._perms$.value.has(perm); }
  anyOf(perms: NormalizedPermission[]): boolean { return perms.some(p => this.can(p)); }
  allOf(perms: NormalizedPermission[]): boolean { return perms.every(p => this.can(p)); }

  get snapshot(): NormalizedPermission[] {
    return Array.from(this._perms$.value);
  }
}
